<app-search-filter
  [filter]="filter"
  (onSearch)="searchRecords($event)"
  (onDisplayRows)="displayRecords($event)"
  (onSort)="sortRecords($event)"
></app-search-filter>

<div class="ui vertical basic segment" *ngIf="success || error">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>
<!-- </div> -->
<div
  fxLayout="row"
  appMargin
  class="ui segment"
  marginB="3"
  fxLayoutGap="10px"
  fxLayoutAlign="start stretch"
  id="dark"
>
  <!-- <div fxFlex="grow">DOCUMENT NAME</div>
  <div fxFlex="20%">DOCUMENT TYPE</div>
  <div fxFlex="20%">DATE ADDED</div>
  <div fxFlex="20%">ADDED BY</div>
  <div fxFlex="20%">STATUS</div>
  <div fxFlex="15%"></div> -->
  <div fxFlex="30%">DOCUMENT TYPE</div>
  <div fxFlex="grow">NO OF DOCUMENTS</div>
  <div fxFlex="10%"></div>
</div>
<div
  class="ui vertical basic segment"
  [ngClass]="{ loading: pending }"
  appMargin="0"
  appPadding="0"
>
  <div
    *ngFor="let record of activeDocuments; let i = index"
    appMargin
    marginB="3"
    appPadding
    paddingB="0"
  >
    <div
      class="ui attached segment"
      fxLayout="row"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
    >
      <div fxFlex="30%">{{ record.key }}</div>
      <div fxFlex="grow">{{ record.value.length }}</div>
      <div fxFlex="10%">
        <button
          class="ui tiny circular icon button"
          (click)="toggleAffiliateTypesVisibility(i)"
          suiPopup
          [popupInverted]="true"
          popupPlacement="bottom"
          [popupText]="
            record?.isCollapsed ? 'Show official Types' : 'Hide official Types'
          "
        >
          <i
            [class]="
              record?.isCollapsed ? 'chevron down icon' : 'chevron up icon'
            "
          ></i>
        </button>
      </div>
    </div>
    <!-- <div fxFlex="grow">{{ document?.documentId?.documentName }}</div>
    <div fxFlex="20%">
      {{ document?.documentId?.documentTypeId?.documentTypeName }}
    </div>
    <div fxFlex="20%">{{ document?.dateCreated | date }}</div>
    <div fxFlex="20%">{{ document?.createdBy | createdBy }}</div>
    <div fxFlex="20%">
      <label
        class="ui circular label"
        [ngClass]="{
          'label-orange': document.status == 'pending',
          'label-red': document.status == 'failed',
          'label-green': document.status == 'verified',
          'label-grey': document.status == 'unavailable'
        }"
        >{{ document?.status | uppercase }}
      </label>
    </div>
    <div fxFlex="15%" class="text-right">
      <div class="ui medium primary basic dropdown button" suiDropdown>
        <div class="text">Actions</div>
        <i class="dropdown icon"></i>
        <div class="menu" suiDropdownMenu appPadding paddingX="3">
          <div
            class="item"
            *isPermitted="{
              id: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
              action: 'read'
            }"
            (click)="download(document)"
          >
            Download Document
          </div>
          <div
            class="item"
            *isPermitted="{
              id: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
              action: 'remove'
            }"
            (click)="onArchive(document)"
          >
            Restore Document
          </div>
          <a
            class="item"
            *isPermitted="{
              id: 'COMPANY_DETAILS_DOCUMENT_UPLOAD',
              action: 'read'
            }"
            target="_blank"
            href="{{ baseUrl }}/public/media/?media={{
              document?.documentId?.documentPath
            }}"
            >View Document</a
          >
        </div>
      </div>
    </div> -->

    <div [suiCollapse]="record?.isCollapsed">
      <div class="ui bottom attached segment" appPadding="0">
        <app-official-list
          [documents]="record.value"
          (onView)="view($event)"
          (onArchive)="onArchive($event)"
          (download)="download($event)"
        ></app-official-list>
      </div>
    </div>
  </div>

  <app-no-record-found
    *ngIf="activeDocuments && activeDocuments.length < 1"
  ></app-no-record-found>
</div>

<div class="ui vertical basic segment">
  <div class="ui two column grid">
    <div class="column middle aligned">
      <div class="ui labeled button">
        <div class="ui tiny icon button" (click)="getPage(1)">
          <i class="refresh icon"></i>
        </div>
        <a class="ui basic label"> {{ totalItems }} Record(s) </a>
      </div>
    </div>
    <div class="column right aligned pagination menu" style="margin-left: auto">
      <sui-pagination
        class="mini"
        [collectionSize]="totalItems"
        [pageSize]="rows"
        [maxSize]="maxSize"
        [hasEllipses]="false"
        [page]="currentPage"
        (pageChange)="nextPage($event)"
      >
      </sui-pagination>
    </div>
  </div>
</div>
